<template lang="pug">
  .new-price
    shForm(title="New Price")
</template>

<script>
import shForm from '@/components/pages/price/Form'

export default {
  name: 'NewPrice',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-price
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/price/New.vue